import { Button, Stack, Typography } from "@mui/material";
import { EvidenceOrderType } from "../../types/evidence";

// The API cannot always tell an initial order from a renewal, and the two print differently.
export default function OrderTypePrompt({ disabled, onPick }: {
  disabled: boolean;
  onPick: (orderType: EvidenceOrderType) => void;
}) {
  return (
    <Stack spacing={1.5}>
      <Typography variant="body2">
        We can&apos;t tell whether this is an initial or a renewal order. Pick one to generate the
        document.
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={() => onPick("initial")} disabled={disabled}>Initial</Button>
        <Button variant="outlined" onClick={() => onPick("renewal")} disabled={disabled}>Renewal</Button>
      </Stack>
    </Stack>
  );
}
